export const Top10 = () => (
    <svg width="175" height="213" viewBox="0 0 175 213" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g opacity="0.5" filter="url(#filter0_f_4279_17262)">
            <rect x="40" y="40.5" width="95" height="132" fill="#FF0402"/>
        </g>
        <defs>
            <filter id="filter0_f_4279_17262" x="0" y="0.5" width="175" height="212" filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB">
                <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
                <feGaussianBlur stdDeviation="20" result="effect1_foregroundBlur_4279_17262"/>
            </filter>
        </defs>
    </svg>

);
export const Top10Mobile = () => (
    <svg width="137" height="141" viewBox="0 0 137 141" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g opacity="0.5" filter="url(#filter0_f_4441_6115)">
            <rect x="35" y="40" width="62" height="61" fill="#FF0402"/>
        </g>
        <defs>
            <filter id="filter0_f_4441_6115" x="-5" y="0" width="142" height="141" filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB">
                <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
                <feGaussianBlur stdDeviation="20" result="effect1_foregroundBlur_4441_6115"/>
            </filter>
        </defs>
    </svg>

);
